import { render, staticRenderFns } from "./KonpoMeisai.vue?vue&type=template&id=22a40a26"
import script from "./KonpoMeisai.vue?vue&type=script&lang=js"
export * from "./KonpoMeisai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports